// Anulación de facturas y notas de crédito — cliente del API
// (SPEC_ANULACION_FACTURAS_Y_NOTAS_CREDITO_v0.2.md §16, en pos-graciela-api/docs).
import apiService from './apiService';

const datos = (response) => response?.data?.data;

// El mensaje de un error de la API ya viene en castellano y con nombre
// (§16.4): se muestra tal cual, nunca un texto genérico.
export const mensajeDeError = (error, porDefecto = 'No se pudo completar la operación.') =>
  error?.response?.data?.message || error?.message || porDefecto;

// `aperturaId`: previsualizar contra una caja elegida (RN-AN20, 2026-10-11).
export const previsualizarAnulacion = async (idVenta, aperturaId = null) =>
  datos(await apiService.get(`/api/sales/${idVenta}/anulacion`, aperturaId ? { apertura_id: aperturaId } : {}));

// `opciones`: { apertura_id, formas_devolucion, motivo_cambio_medio } (§16.2).
// Sin ellas, la caja propia y lo cobrado.
export const anularFactura = async (idVenta, motivo, opciones = {}) =>
  datos(await apiService.post(`/api/sales/${idVenta}/anular`, { motivo, ...opciones }));

export const entregaDeFactura = async (idVenta) =>
  datos(await apiService.get(`/api/sales/${idVenta}/entrega`));

export const listarNotasCredito = async (filtros = {}) =>
  datos(await apiService.get('/api/notas-credito', filtros));

export const comprobanteNotaCredito = async (idDevolucion) =>
  datos(await apiService.get(`/api/notas-credito/${idDevolucion}/comprobante`));

export const ticketNotaCredito = async (idDevolucion) =>
  datos(await apiService.get(`/api/notas-credito/${idDevolucion}/ticket`));

// Texto del instrumento para la fila del histórico y el resultado.
export const textoInstrumento = (instrumento, referencia = null) => {
  switch (String(instrumento || '').toUpperCase()) {
    case 'EVENTO_CANCELACION': return 'Anulada ante la SET';
    case 'NOTA_CREDITO': return referencia ? `Nota de crédito ${referencia}` : 'Anulada con nota de crédito';
    case 'CANCEL_SEND': return 'Retirada antes de emitirse';
    case 'NINGUNO': return 'Anulada (sin documento fiscal)';
    default: return null;
  }
};

export const textoInstrumentoPrevisto = (instrumento) => {
  switch (String(instrumento || '').toUpperCase()) {
    case 'EVENTO_CANCELACION': return 'La factura se cancela ante la SET (está dentro de las 24 horas).';
    case 'NOTA_CREDITO': return 'Se emite una nota de crédito por el total (pasaron más de 24 horas).';
    case 'CANCEL_SEND': return 'La factura todavía no llegó a la SET: se retira antes de emitirse.';
    case 'NINGUNO': return 'No hay documento fiscal vigente que anular: se anula sólo en el sistema.';
    default: return 'No se puede determinar todavía cómo se anula ante la SET.';
  }
};

export default {
  mensajeDeError,
  previsualizarAnulacion,
  anularFactura,
  entregaDeFactura,
  listarNotasCredito,
  comprobanteNotaCredito,
  ticketNotaCredito,
  textoInstrumento,
  textoInstrumentoPrevisto
};
